import { render, staticRenderFns } from "./driverprofile.vue?vue&type=template&id=21f0497c&scoped=true"
import script from "./driverprofile.js?vue&type=script&lang=js&external"
export * from "./driverprofile.js?vue&type=script&lang=js&external"
import style0 from "./driverprofile.vue?vue&type=style&index=0&id=21f0497c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f0497c",
  null
  
)

export default component.exports